import { HttpErrorResponse } from '@angular/common/http';

export class Error {
    errorAPI: HttpErrorResponse;
    errorLogIn: HttpErrorResponse;
    errorOfficeContext: string;
}
